import { ROLES } from './roles'
import {
  LayoutDashboard, BarChart2, Building2, UserCog, Baby, Users, UserCheck,
  Zap, GraduationCap, Target, Shield, Wallet, Tablet, Monitor,
  Bell, BellRing, Trophy, Video, MessageSquare, ShoppingBag, UsersRound, ShieldCheck,
  Activity, CalendarRange, MapPin, Map, Flame, Palette, Star, ScrollText, Smartphone, Search, Radio, History, Trash2, Compass, Gift, Undo2, Heart, UserMinus, ArrowLeftRight, Bug, BadgeCheck, QrCode, Settings,
} from 'lucide-vue-next'

const ALL      = Object.values(ROLES)
const GESTAO   = [ROLES.ADMIN, ROLES.GERENTE]
const NO_BANCO = [ROLES.ADMIN, ROLES.GERENTE, ROLES.TAUALEGRE]
const BANCO    = [ROLES.ADMIN, ROLES.GERENTE, ROLES.OPERADOR_BANCO]

export const navigation = [
  {
    section: 'VISÃO GERAL',
    items: [
      { label: 'Dashboard',  route: 'dashboard',  icon: LayoutDashboard, roles: ALL },
      { label: 'Relatórios', route: 'relatorios', icon: BarChart2,        roles: GESTAO },
    ],
  },
  {
    section: 'CADASTRO',
    items: [
      {
        label: 'Hotel',
        icon: Building2,
        roles: GESTAO,
        children: [
          { label: 'Hotéis', route: 'hotels', icon: Building2, roles: [ROLES.ADMIN] },
          { label: 'Mapa',   route: 'mapa',   icon: Map,       roles: GESTAO },
        ],
      },
      { label: 'Funcionários', route: 'employees',        icon: UserCog,    roles: GESTAO },
      { label: 'Taualegres',    route: 'taualegres',       icon: UserCheck,  roles: GESTAO },
      {
        label: 'Usuários',
        icon: UsersRound,
        roles: NO_BANCO,
        children: [
          { label: 'Responsáveis', route: 'account-holders', icon: Users,      roles: NO_BANCO },
          { label: 'Crianças',     route: 'children',         icon: Baby,       roles: NO_BANCO },
          { label: 'Guardiões',    route: 'guardians',        icon: ShieldCheck, roles: NO_BANCO },
          { label: 'Separar responsáveis', route: 'separar-responsaveis', icon: UserMinus, roles: GESTAO },
          // Tickets #131-#134 (parent #129): pedidos pendentes de transferência
          // de hotel gerados quando a cascata de identidade do register-family
          // não encontra match -- mesmo padrão visual/navegação de Mérito
          // pendente, GESTAO-only.
          { label: 'Transferências pendentes', route: 'transferencias-hotel-pendentes', icon: ArrowLeftRight, roles: GESTAO },
          // #232: jornada de ativação das contas (inclui a aba de contas de teste).
          { label: 'Central de Ativação', route: 'central-ativacao', icon: BadgeCheck, adminOrDev: true },
        ],
      },
      {
        label: 'Atividades e Turmas',
        icon: CalendarRange,
        roles: GESTAO,
        children: [
          { label: 'Banco de Atividade', route: 'activity-types', icon: Zap,           roles: GESTAO },
          { label: 'Banco de Turmas',    route: 'class-types',    icon: GraduationCap, roles: GESTAO },
          { label: 'Locais',             route: 'locations',       icon: MapPin,        roles: GESTAO },
          { label: 'Restaurar saídas',   route: 'restaurar-saidas', icon: Undo2,        roles: GESTAO },
        ],
      },
      {
        label: 'Missões',
        icon: Target,
        roles: GESTAO,
        children: [
          { label: 'Missões',        route: 'missions',    icon: Target,     roles: GESTAO },
          { label: 'Nomes dos QR Codes', route: 'qr-nomes', icon: QrCode, roles: GESTAO },
          { label: 'Histórico de Missões', route: 'log-criacao', icon: ScrollText, roles: GESTAO },
        ],
      },
      { label: 'Patentes',          route: 'ranks',           icon: Shield,      roles: GESTAO },
      {
        label: 'Banco - Realegres',
        icon: Wallet,
        roles: BANCO,
        children: [
          { label: 'Realegres',             route: 'banco-realegres', icon: Wallet,      roles: BANCO },
          { label: 'Produtos',              route: 'produtos',        icon: ShoppingBag, roles: BANCO },
          { label: 'Histórico de Resgates', route: 'resgates',        icon: Gift,        roles: BANCO },
          // Vínculo de pulseira (Banqueiro T6, #302): só o Banqueiro vê esse
          // item -- Admin/Gerente já vinculam pulseira pelas telas completas
          // de Crianças/Guardiões (botão "Ler NFC"), sem precisar duplicar
          // no menu (ver #296, história 19).
          { label: 'Vincular pulseira',     route: 'banco-vincular-pulseira', icon: Radio, roles: [ROLES.OPERADOR_BANCO] },
        ],
      },
      {
        label: 'Energia',
        icon: Flame,
        roles: NO_BANCO,
        children: [
          { label: 'Conceder energia', route: 'energia-conceder', icon: Flame,  roles: NO_BANCO },
          { label: 'Extrato de energia', route: 'energia-extrato', icon: History, roles: GESTAO },
          { label: 'Bônus de mérito',  route: 'merito-pendente',  icon: Star,   roles: GESTAO },
          { label: 'Concessões manuais', route: 'energia-concessoes-manuais', icon: BarChart2, roles: GESTAO },
        ],
      },
    ],
  },
  {
    section: 'INSIGHTS',
    items: [
      { label: 'Rankings',              route: 'rankings',              icon: Trophy, roles: GESTAO },
      { label: 'Mais Favoritados',      route: 'favoritos',             icon: Heart,  roles: GESTAO },
      { label: 'Distribuição de Patentes', route: 'distribuicao-patentes', icon: Shield, roles: GESTAO },
    ],
  },
  {
    section: 'DIA A DIA',
    items: [
      { label: 'Programação',      route: 'turmas',              icon: CalendarRange, roles: GESTAO },
      { label: 'Acontecendo hoje',  route: 'dia-a-dia-agora',     icon: Radio,         roles: GESTAO },
      { label: 'Histórico',         route: 'dia-a-dia-historico', icon: History,       roles: GESTAO },
    ],
  },
  {
    section: 'CONTEÚDO',
    items: [
      { label: 'Vídeos', route: 'videos', icon: Video, roles: GESTAO },
      { label: 'Jornada', route: 'jornada-midia', icon: Compass, roles: GESTAO },
    ],
  },
  {
    section: 'APARÊNCIA',
    items: [
      { label: 'Tema do App', route: 'tema', icon: Palette, roles: [ROLES.ADMIN] },
    ],
  },
  {
    section: 'METAS',
    items: [
      { label: 'Avaliações', route: 'avaliacoes', icon: Star, roles: GESTAO },
    ],
  },
  {
    section: 'COMUNICAÇÃO',
    items: [
      { label: 'Mensagens',     route: 'mensagens',     icon: MessageSquare, roles: ALL },
      { label: 'Notificações',  route: 'notifications', icon: Bell,          roles: ALL },
      { label: 'Avisos de chegada', route: 'avisos-chegada', icon: Bell,     roles: GESTAO },
      { label: 'Métricas de push', route: 'push-metrics', icon: BellRing,    roles: [ROLES.ADMIN] },
      { label: 'Totens Tauá',   route: 'totens',        icon: Tablet,        roles: GESTAO },
      { label: 'Painéis Tauá',  route: 'paineis',       icon: Monitor,       roles: GESTAO },
    ],
  },
  {
    section: 'DESENVOLVIMENTO',
    devOnly: true,
    items: [
      { label: 'Logs',          route: 'dev-logs',        icon: ScrollText,  devOnly: true },
      { label: 'Versão Equipe Tauálegres', route: 'dev-app-version', icon: Smartphone,  devOnly: true },
      { label: 'Consulta VOLUX', route: 'dev-volux',      icon: Search,      devOnly: true },
      { label: 'Purga de hotel de teste', route: 'dev-hotel-purge', icon: Trash2, devOnly: true },
      { label: 'Crash Reporting', route: 'dev-crash-reporting', icon: Bug, devOnly: true },
      { label: 'Métricas Jornada Taualegre', route: 'dev-account-metrics', icon: Activity, devOnly: true },
      { label: 'Configurações', route: 'dev-settings', icon: Settings, devOnly: true },
    ],
  },
]
